import P4 from './P4.svelte';
import serviceWorker from '!!file-loader?name=sw.js!./sw.js';
import {LoginModal} from '../common/gandi/login-modal.js';
import {getTouchSession, postLoginByPassword, postMemberDetail} from '../common/gandi/api.js';

window.lm = new LoginModal({
  loginByPassword: async (loginKey, password) => {
    const response = await postLoginByPassword(loginKey, 'STUDY_COMMUNITY', password, {
      "device": "Web",
      "browser": "Gandi Packager",
      "scene": null
    });
      
    return response;
  },
    
  touchSession: async (token) => {
    return await getTouchSession(token);
  },
    
  fetchMemberDetail: async (token) => {
    return await postMemberDetail(token);
  },
    
  onLoginSuccess: () => {
      if (confirm('已登录其他账户，需要刷新网页')) location.reload();
  },
    
  onLoginFail: (error) => {
    console.log('Failed to login', error);
  }
});

const app = new P4({
  target: document.getElementById('app')
});

document.body.setAttribute('p4-loaded', '');

if (__ENABLE_SERVICE_WORKER__ && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(serviceWorker)
      .then(() => {
        console.log('SW registered');
      }).catch((error) => {
        console.log('SW error', error);
      });
  });
}
